import { Component } from '@angular/core';

@Component({
  selector: 'app-provider-terms',
  templateUrl: './provider-terms.component.html',
  styleUrls: ['./provider-terms.component.scss']
})
export class ProviderTermsComponent {}
